// extracted by mini-css-extract-plugin
export default {"description":"changeStatus_description__OR7Qa","content":"changeStatus_content__VIrzu","contentItem":"changeStatus_contentItem__kQYjh","status":"changeStatus_status__cpy6F"};